import { render } from "./GauntletIcon.vue?vue&type=template&id=040edd23&ts=true"
import script from "./GauntletIcon.vue?vue&type=script&lang=ts"
export * from "./GauntletIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__